import { render, staticRenderFns } from "./BiologicalData.vue?vue&type=template&id=3814f2a9"
import script from "./BiologicalData.vue?vue&type=script&lang=js"
export * from "./BiologicalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports